module.exports = __webpack_public_path__ + "static/media/LOGO_SIMA-02 (1).a86d00e6.jpg";